import WorkOutlineIcon from '@mui/icons-material/WorkOutline';
import { Box, Button, Card, CardContent, Stack, Typography } from '@mui/material';

import { useBecomeCandidate } from '@/features/onboarding/hooks/useBecomeCandidate';

/**
 * The "start a Candidate journey later" entry point My Profile promises (onboarding's footer links
 * here). An account that already resolved to a company or staff workspace never sees the onboarding
 * chooser again (`OnboardingPage` redirects it away), so this card is the only reachable way to opt in
 * after the fact. Shown only while the account has no
 * Candidate persona yet; once granted, `ProfilePage` never renders it again (`hasCandidateWorkspace`).
 */
export function CandidateOptInCard() {
  const { becomeCandidate, becoming } = useBecomeCandidate();

  return (
    <Card variant="outlined">
      <CardContent>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems={{ sm: 'center' }}>
          <Box sx={{ color: 'primary.main', display: 'flex' }}>
            <WorkOutlineIcon fontSize="large" />
          </Box>
          <Stack spacing={0.5} sx={{ flexGrow: 1 }}>
            <Typography variant="subtitle1" fontWeight={600}>
              Looking for your next role?
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Create a Career Profile to upload your resume and get discovered by companies hiring on
              Willnq, independent of any company workspace you already belong to.
            </Typography>
          </Stack>
          <Button
            variant="contained"
            onClick={() => void becomeCandidate()}
            disabled={becoming}
            sx={{ whiteSpace: 'nowrap' }}
          >
            {becoming ? 'Setting up…' : 'Create Career Profile'}
          </Button>
        </Stack>
      </CardContent>
    </Card>
  );
}
